<template>
<div class="primary-nav-item" @click="selectContent(item)">
  <div class="item-title">
    <span :class="{ active: item.isActive }">{{ item.langTitle }}</span>
  </div>
</div>
</template>

<script>
import { shareMixin } from 'shareMixin';
import { errorsComputed, mainComputed, primaryNavComputed, primaryNavMethods, planComputed, planMethods } from '@state/helpers';

export default {
  mixins: [shareMixin],
  components: {},
  props: {
    items: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      selectedItem: null,
    };
  },
  computed: {
    ...errorsComputed,
    ...mainComputed,
    ...planComputed,
    ...primaryNavComputed,
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
    setActiveRootState() {
      if (!this.currentPrimaryView.title) {
        this.items[0].isActive = true;
      }
    },
  },
  mounted() {
    this.setActiveRootState;
  },
  methods: {
    ...planMethods,
    ...primaryNavMethods,
    resetActiveState(item) {
      this.items.forEach((item) => {
        if (item && item.isActive) {
          item.isActive = false;
        }
      });

      if (item && item.title === 'Calendar') {
        item.isActive = true;
      }
    },
    async selectContent(item) {
      this.selectedItem = item;

      if (this.dishToAdd) {
        this.setDishToAdd(null);
      }

      await this.resetActiveState();
      this.navigateDeeperPrimary(item);
      item.isActive = true;
      if (item.component === 'Plans') {
        this.updateShareableUrl(item.component);
      }
    },
  },
  watch: {
    currentPrimaryView(newVal, oldVal) {
      if (!newVal.component) {
        this.resetActiveState(newVal);
        this.setActiveRootState;
      } else if (newVal.title !== oldVal.title) {
        if (this.item.component === newVal.component) {
          this.selectContent(this.item);
        }
      }
    },
    retry(newVal, oldVal) {
      if (this.selectedItem.title === 'Recipes' && this.userAction === 'allDishes') {
        this.selectContent(this.selectedItem);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.primary-nav-item {
  &:not(:last-child) {
    padding-right: 2rem;
  }

  .item-title,
  .btn-browse {
    color: $color-navbar-link;
    font-size: 1.6rem;
  }

  .item-title span {
    &:hover,
    &.active {
      border-bottom: 2px solid $color-action;
      cursor: pointer;
      text-decoration: none;
    }
  }

  .btn-browse {
    color: $color-navbar-btn-text;
  }
}
</style>
